import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps {
  name: string;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  helperText?: string;
  disabled?: boolean;
  className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  value,
  onChange,
  helperText,
  disabled,
  className = '',
}) => {
  return (
    <div className={className}>
      <label
        className={`
          group inline-flex items-center cursor-pointer select-none
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      >
        <div className="relative">
          <input
            type="checkbox"
            name={name}
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            className="sr-only peer"
          />
          <div
            className={`
              w-5 h-5 rounded-md border-2 transition-all duration-200
              flex items-center justify-center
              ${value
                ? 'bg-violet-600 border-violet-600'
                : 'bg-white border-slate-300 group-hover:border-slate-400'}
              ${disabled ? '' : 'peer-focus:ring-4 peer-focus:ring-violet-100'}
            `}
          >
            {value && <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />}
          </div>
        </div>
        <span className="ml-3 text-sm font-medium text-slate-700 group-hover:text-slate-900 transition-colors">
          {label}
        </span>
      </label>
      {helperText && (
        <p className="text-slate-500 text-xs mt-2 ml-8">{helperText}</p>
      )}
    </div>
  );
};
